var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"navigation clearfix\">\n<button id=\"navigation-next-button\" type=\"submit\" ng-hide=\"$ctrl.hideSelectButton\" class=\"btn btn-primary\" ng-click=\"$ctrl.onNext()\" ng-disabled=\"$ctrl.isDisabled\" translate=\"{{$ctrl.nextTranslationKey}}\">\n</button>\n<button id=\"navigation-back-button\" type=\"button\" class=\"btn btn-default btn-back\" bb-debounce ng-click=\"$ctrl.loadPreviousStep()\" ng-show=\"$ctrl.currentStep > 1\" translate=\"PUBLIC_BOOKING.CHECK_ITEMS.BACK_BTN\">\n</button>\n</div>\n</div>";
var id1="public-booking/step-navigation/step-navigation.component.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/step-navigation/step-navigation.component.html
// module id = 1238
// module chunks = 0